import { AxiosInstance, AxiosResponse } from "axios";
import {
  ActiveTerminalType,
  ConsultLimitsTerminalResponseDTO,
  InvoiceAndDealPaymentResponseDTO,
  InvoiceAndDealPaymentType,
  ValidateTerminalResponseDTO
} from "../entities/Terminal";

const resourcePrefix = "/Terminal";

export class TerminalResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async validateTerminal(
    tokenData: string
  ): Promise<AxiosResponse<ValidateTerminalResponseDTO>> {
    return this.apiProvider.get<ValidateTerminalResponseDTO>(
      `${resourcePrefix}/ValidarTerminal`,
      {
        headers: {
          Authorization: `Bearer ${tokenData}`
        }
      }
    );
  }

  async activeTerminal(payload: ActiveTerminalType): Promise<AxiosResponse> {
    return this.apiProvider.post(`${resourcePrefix}/AtivarTerminal`, payload);
  }

  async sendTransactionReceiptOnSMS(lngAutorizacao: number, strDdd: string, strFone: string): Promise<AxiosResponse> {
    return this.apiProvider.post(`${resourcePrefix}/EnviarComprovanteTransacao?lngAutorizacao=${lngAutorizacao}&strDdd=${strDdd}&strFone=${strFone}`);
  }

  async consultLimitsTerminal(
    card: string
  ): Promise<AxiosResponse<ConsultLimitsTerminalResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarLimites?strPlastico=${card}`
    );
  }
  async invoicePaymentTerminal(
    data: InvoiceAndDealPaymentType
  ): Promise<AxiosResponse<InvoiceAndDealPaymentResponseDTO>> {
    return this.apiProvider.post(`${resourcePrefix}/RegistrarPagamento`, data, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
}
